import React from "react";
import Layout from "./src/components/Layout";
import "./src/styles/global.css";
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css";

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location);
  setTimeout(() => {
    window.scrollTo(...(currentPosition || [0, 0]));
  }, 0);
  return false;
};

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>;
}
